// extracted by mini-css-extract-plugin
export default {"navBox":"FooterNav_navBox__qoKTk","section":"FooterNav_section__YbCKT","title":"FooterNav_title__11vap","nav":"FooterNav_nav__X3ym-"};